<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-exclamation-triangle title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.triggerRules' | transloco}}</p>
        <p>{{'menu.descriptions.triggerRules' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
              <button
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                [label]="'common.delete' | transloco"
                [disabled]="selected.length == 0"
                (click)="confirmAndDeleteSelected()"
                pButton
                pRipple
                class="p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
              ></button>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(selection)]="selected"
          [(first)]="first"
          [(rows)]="rows"
          [value]="rules"
          [totalRecords]="totalRules"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          sortField="name"
          styleClass="p-datatable-striped"
          dataKey="dataKey"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="width: 3rem"></th>
              <th scope="col" style="width: 3rem" *ngIf="'ROLE_OPERATOR' | userHasRole"></th>
              <th scope="col" pSortableColumn="name">
                {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
              <th pSortableColumn="category" scope="col">
                {{ 'attribute.category' | transloco }}
                <p-sortIcon field="category"></p-sortIcon>
              </th>
              <th scope="col" pSortableColumn="active">
                {{'attribute.active' | transloco}}<p-sortIcon field="active"></p-sortIcon></th>
              <th scope="col">
                {{'attribute.condition' | transloco}}</th>
              <th scope="col" pSortableColumn="tenant.name" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}<p-sortIcon field="tenant.name"></p-sortIcon></th>
              <th scope="col" pSortableColumn="organization.name">
                {{'model.organization' | transloco}}<p-sortIcon field="organization.name"></p-sortIcon></th>
              <th scope="col" *ngIf="'ROLE_OPERATOR' | userHasRole" class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rule let-expanded="expanded">
            <tr *ngIf="!loadingRules" class="fadein">
              <td>
                <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
                <button
                  [pRowToggler]="rule"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  pButton
                  pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  type="button"
                ></button>
              </td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox [value]="rule"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <p class="text-right md:text-left">{{rule.name}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.category' | transloco }}</span>
                <p>{{ 'model.triggerCategories.' + rule.category.toLowerCase() | transloco }}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.active' | transloco}}</span>
                <p class="text-right md:text-left" *ngIf="rule.active">{{'common.active' | transloco}}</p>
                <p class="text-right md:text-left" *ngIf="!rule.active">{{'common.inactive' | transloco}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.condition' | transloco}}</span>
                <p-tag value="{{rule.type}}({{rule.expression}})" severity="info"></p-tag>
              </td>
              <td  *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="rule.tenant" [routerLink]="'/tenants/' + rule.tenant.uuid + '/details'" class="text-right md:text-left">
                  {{rule.tenant.name}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <p class="text-right md:text-left">{{rule.organization ? rule.organization.name : ''}}</p>
              </td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole">
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="rule.tenant.uuid + '/' + (rule.organization ? rule.organization.uuid : 'global')
                     + '/' + rule.name + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    *ngIf="'ROLE_OPERATOR' | userHasRole"
                    (click)="confirmAndDelete(rule)"
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                    pButton
                    pRipple
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingRules" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-rule>
            <tr>
              <td colspan="8">
                <div class="grid">
                  <div class="col-12">
                    <b>{{'attribute.appliedTo' | transloco}}:</b>
                  </div>
                  <div class="col-12">
                    <ngx-json-viewer *ngIf="rule.appliedTo" [json]="rule.appliedTo"></ngx-json-viewer>
                    <div *ngIf="!rule.appliedTo"><i>{{'empty.appliedTo' | transloco}}</i></div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalRules == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalRules > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalRules ? totalRules : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalRules}}
              {{(totalRules > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="name">{{'attribute.name' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input
            [(ngModel)]="currentFilters.name"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            pInputText
            appAutoFocus
            class="w-full"
            id="name"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label>{{'attribute.active' | transloco}}</label>
        </div>
        <div class="col-12">
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.active"
              [label]="'misc.allTypes' | transloco"
              class="mr-3"
              name="active"
              value="null"
            ></p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.active"
              [label]="'misc.activeOnly' | transloco"
              name="active"
              value="true"
            ></p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.active"
              [label]="'misc.inactiveOnly' | transloco"
              name="active"
              value="false"
            ></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
        <div class="col-12 form-field">
          <label for="tenant">{{'model.tenant' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.tenantUuids"
            [placeholder]="'select.generic' | transloco"
            [options]="tenants"
            [filter]="true"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            optionValue="uuid"
            filterBy="name"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(
            currentFilters.name ||
            currentFilters.active ||
            currentFilters.tenantUuids
          )"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </p-sidebar>
</div>
